@media screen {
    .outer-container {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        width: 100vw;
    }

    .inner-container {
        display: flex;
        flex: 1;
        width: 100%;
        max-height: 100vh;
        gap: 40px;
        padding: 40px;
        box-sizing: border-box;
    }

    .left-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50%;
    }

    .left-header {
        width: 100%;
    }

    .left-main {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .left-main > * {
        width: 100%;
        max-width: 400px;
    }

    .left-mobile-title {
        display: none;
        width: 100%;
    }

    .mobile-footer {
        display: none;
    }

    .right-content {
        display: flex;
        flex-direction: column;
        width: 50%;
        padding-top: 80px;
        background-color: var(--blue-bg);
        border-radius: 16px;
        overflow: hidden;
        justify-content: space-between;
        position: relative;
    }

    .right-content--with-background {
        padding-top: 0;
        background-color: transparent;
        border-radius: 24px;
        isolation: isolate;
    }

    .right-pane-background {
        position: absolute;
        inset: 0;
        z-index: 0;
        overflow: hidden;
        border-radius: 24px;
    }

    .right-pane-background img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 24px;
    }

    .illustration-panel {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 8px;
        justify-content: space-evenly;
    }

    .illustration-panel--centered {
        align-items: center;
        justify-content: center;
    }

    .illustration {
        z-index: 1;
    }

    .illustration img {
        width: 100%;
        height: auto;
        max-height: 50vh;
        object-fit: contain;
    }

    .desktop-footer {
        margin-top: -64px;
        transform: translateY(12px);
        z-index: 0;
    }
}

@media (max-height: 812px) {
    .inner-container {
        padding: 24px;
    }
}

@media (max-height: 736px) and (max-width: 1992px) {
    .inner-container {
        max-height: none;
        padding: 24px;
    }

    .left-header {
        padding-bottom: 16px;
    }
}

@media (max-width: 1192px) {
    .inner-container {
        max-height: none;
        padding: 24px;
    }

    .right-content {
        display: none;
    }

    .left-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;
        gap: 24px;
        justify-content: space-between;
    }

    .left-mobile-title {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .mobile-footer {
        display: flex;
        width: calc(100% + 48px);
        margin: 0 -24px -24px -24px;
    }

    .left-header {
        padding-bottom: 16px;
    }

    .left-main {
        flex-grow: 0;
    }

    .left-mobile-title > * {
        width: 100%;
        max-width: 400px;
    }
}
